// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PageTitleCount from "@awc/App/Components/Common/PageTitleCount";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuotesDataView } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quotesDataView: getQuotesDataView(state, state.pages.rfqMyQuotes.getQuotesParameter),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const RfqMyQuotesTitleCount: FC<Props> = ({ quotesDataView }) => {
    const quotesCount =
        quotesDataView.value && quotesDataView.pagination ? quotesDataView.pagination.totalItemCount : 0;

    return <PageTitleCount countNumber={quotesCount} noun="Quote" showCountOnly={true} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(RfqMyQuotesTitleCount),
    definition: {
        group: "RFQ My Quotes",
        displayName: "Title Count",
        allowedContexts: ["RfqMyQuotesPage"],
    },
};

export default widgetModule;
